import React from 'react'
import PropTypes from 'prop-types'

import Slider from 'rc-slider';

import 'rc-slider/assets/index.css'
import styles from './../style/Komfort.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class Komfort extends React.Component {
  
  state = {
    mounted: false,
    slyde: 3
  }

  onSliderChange = ( value ) => {
    this.setState({
      slyde: value
    })
  }

  componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  render() {

    const { data, assets_path } = this.props,
    { mounted, slyde } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
            className={styles.title}
          />
          <div className={styles.content}>
            <div>
              <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
              <Image src={data?.image} width={446} height={275} />
            </div>
            <div>
              <div className={styles.block1}>
                <div className={styles.block1_titleblock}>
                  <div className={styles.block1_titleblock_title}>Ощутимая разница</div>
                  <div>[Значения температур]</div>
                </div>
                <div className={styles.block1_content}>
                  <div>
                    <div className={styles.block1_titleblock2}>
                      <div className={styles.block1_titleblock2_icon}>
                        <Image src={`/${assets_path}/images/routing.svg`} width={21} height={21} />
                      </div>
                      <div>
                        <div>Температура на улице</div>
                        <div className={styles.block1_titleblock2_text}>Потяните за ползунок</div>
                      </div>
                    </div>
                    {mounted &&
                      <>
                        <Slider
                          dots
                          step={1}
                          defaultValue={3}
                          max={4}
                          handleStyle={{
                            height: '22px',
                            width: '22px',
                            marginTop: '3px',
                            marginLeft: '0px',
                            border: '0px',
                            backgroundColor: '#00C775',
                            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'12\' height=\'12\' viewBox=\'0 0 12 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M5.88545 0.147142C5.85753 0.174251 5.83659 0.723182 5.83659 1.37377C5.83659 2.01758 5.81565 2.54618 5.78773 2.54618C5.7598 2.54618 5.46663 2.28865 5.13157 1.97014C4.70576 1.56352 4.48937 1.40765 4.41259 1.43476C4.18921 1.51608 4.31486 1.71261 5.06874 2.44452L5.83659 3.18999V4.41661C5.83659 5.08753 5.81565 5.65679 5.79471 5.67712C5.75282 5.72456 3.5889 4.53182 3.5191 4.42339C3.49816 4.3895 3.35855 3.91512 3.21196 3.38652C2.97463 2.47841 2.93972 2.41064 2.78615 2.41064C2.58372 2.41064 2.58372 2.47841 2.80012 3.29164C2.89784 3.64404 2.97463 3.98289 2.97463 4.05066C2.97463 4.13198 2.70937 4.00999 1.95549 3.58982C1.39008 3.27131 0.880506 3.02056 0.817682 3.03412C0.754859 3.04767 0.705996 3.11544 0.705996 3.18321C0.705996 3.27131 0.985212 3.46106 1.71815 3.87446C2.26961 4.17942 2.73729 4.45727 2.74427 4.49116C2.75823 4.52504 2.54184 4.60637 2.26262 4.67413C1.22953 4.93166 1.08992 4.98587 1.08992 5.12141C1.08992 5.18918 1.1318 5.25695 1.18066 5.27728C1.22255 5.29084 1.72513 5.18918 2.29055 5.04009L3.32365 4.78257L4.44051 5.39927C5.05478 5.73811 5.55737 6.04308 5.55737 6.07018C5.55737 6.09729 5.05478 6.40225 4.44051 6.7411L3.32365 7.3578L2.40223 7.12061C1.32027 6.84275 1.08992 6.82242 1.08992 7.01218C1.08992 7.08672 1.14576 7.16127 1.21557 7.1816C1.27839 7.19515 1.64835 7.29681 2.03227 7.39846C2.41619 7.50012 2.75125 7.60177 2.77917 7.6221C2.8071 7.64243 2.33941 7.93384 1.74608 8.26591C0.95729 8.69963 0.671094 8.88939 0.685055 8.97071C0.726937 9.18757 0.929369 9.12658 1.79494 8.63864C2.26961 8.37434 2.74427 8.11682 2.842 8.0626L3.03047 7.9745L2.82804 8.73352C2.58372 9.67551 2.57674 9.72973 2.78615 9.72973C2.93972 9.72973 2.97463 9.66196 3.22592 8.70641L3.50514 7.67632L4.5871 7.07317C5.17345 6.73432 5.70396 6.44969 5.75282 6.42936C5.81565 6.40225 5.83659 6.68011 5.83659 7.67632V8.95038L5.06874 9.69584C4.31486 10.4278 4.18921 10.6243 4.41259 10.7056C4.48937 10.7327 4.70576 10.5768 5.13157 10.1702C5.46663 9.85171 5.7598 9.59419 5.78773 9.59419C5.81565 9.59419 5.84357 10.1363 5.85055 10.8005C5.87149 11.9458 5.87847 12 6.0111 12C6.14373 12 6.15071 11.9458 6.17165 10.753L6.18561 9.50609L6.84177 10.1296C7.30247 10.5633 7.52584 10.7327 7.60961 10.7056C7.83298 10.6243 7.70733 10.4278 6.95345 9.69584L6.18561 8.95038V7.68309C6.18561 6.97829 6.20655 6.40903 6.22749 6.40903C6.24843 6.40903 6.77196 6.70044 7.4002 7.05284L8.53102 7.68987L8.80326 8.71319C9.05455 9.6484 9.09643 9.72973 9.23604 9.72973C9.44545 9.72973 9.43847 9.65518 9.19416 8.74707C9.07549 8.34046 8.99173 7.99483 9.00569 7.98806C9.01267 7.98128 9.48734 8.23202 10.0597 8.55054C10.6321 8.86228 11.1487 9.11303 11.2045 9.10625C11.2673 9.0927 11.3162 9.02493 11.3162 8.95716C11.3162 8.86228 11.037 8.6793 10.304 8.26591C9.74561 7.95417 9.28491 7.67632 9.27792 7.64921C9.26396 7.61532 9.45942 7.54078 9.71071 7.47978C10.7997 7.20193 10.9323 7.14772 10.9323 7.01218C10.9323 6.82242 10.7019 6.84275 9.61996 7.12061L8.69157 7.3578L7.58169 6.7411C6.96741 6.40225 6.46482 6.09729 6.46482 6.07018C6.46482 6.04308 6.96741 5.74489 7.58169 5.39927L8.69157 4.77579L9.72467 5.04009C10.2901 5.1824 10.7997 5.29084 10.8485 5.27728C10.8904 5.25695 10.9323 5.18918 10.9323 5.12141C10.9323 4.99265 10.7857 4.93843 9.71071 4.66058C9.45942 4.59959 9.26396 4.52504 9.27094 4.49793C9.28491 4.46405 9.74561 4.18619 10.304 3.87446C11.03 3.46784 11.3162 3.27131 11.3162 3.18321C11.3162 3.11544 11.2673 3.04767 11.2045 3.03412C11.1487 3.02734 10.6391 3.27809 10.0737 3.5966C9.51526 3.91512 9.04059 4.17264 9.01965 4.17264C9.00569 4.17264 9.08247 3.82702 9.19416 3.40685C9.43847 2.46485 9.44545 2.39708 9.24302 2.42419C9.10341 2.44452 9.04757 2.55973 8.80326 3.44751L8.51706 4.45727L7.39322 5.08753C6.77196 5.43315 6.24843 5.70423 6.22749 5.67712C6.20655 5.65679 6.18561 5.08753 6.18561 4.41661V3.18999L6.95345 2.44452C7.70733 1.71261 7.83298 1.51608 7.60961 1.43476C7.53282 1.40765 7.31643 1.56352 6.89063 1.97014C6.55557 2.28865 6.26239 2.54618 6.23447 2.54618C6.20655 2.54618 6.17863 2.00402 6.17165 1.34666C6.15071 0.323342 6.13675 0.140366 6.046 0.120034C5.98318 0.113257 5.91337 0.120034 5.88545 0.147142Z\' fill=\'white\'/%3E%3C/svg%3E")',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center center'
                          }}
                          railStyle={{
                            backgroundColor: '#F6F6F6',
                            height: '28px',
                            borderRadius: '14px',
                            border: '0px',
                            width: 'calc(100% + 28px)',
                            marginLeft: '-14px'
                          }}
                          dotStyle={{ display: 'none' }}
                          trackStyle={{ display: 'none' }}
                          className={styles.block1_slyder}
                          onChange={this.onSliderChange}
                        />
                        <div className={styles.block1_slyder_nums}>
                          <div>-5°</div>
                          <div>-10°</div>
                          <div>-15°</div>
                          <div>-20°</div>
                          <div>-30°</div>
                        </div>
                      </>
                    }
                  </div>
                  <div>
                    <div className={styles.block1_titleblock2}>
                      <div className={styles.block1_titleblock2_icon}>
                        <Image src={`/${assets_path}/images/home-w.svg`} width={21} height={21} />
                      </div>
                      <div>
                        <div>Температура в помещении</div>
                      </div>
                    </div>
                    <div className={styles.block1_windows}>
                      {data?.slyder.map( ( elm, k ) => (
                        <div key={k}>
                          <Image src={elm?.image} width={36} height={57} />
                          <div className={styles.block1_windows_temp}>+{elm?.steps[slyde]}°</div>
                          <div className={styles.block1_windows_name} dangerouslySetInnerHTML={{__html: elm?.name}} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.bblocks}>
                <div className={styles.bblocks_card}>
                  <div className={styles.bblocks_card_top}>
                    <div className={styles.bblocks_card_top_icon}>
                      <Image src={`/${assets_path}/images/sun.svg`} width={21} height={21} />
                    </div>
                    <div className={styles.bblocks_card_top_sep} />
                    <div className={styles.bblocks_card_top_temp}>[+23°]</div>
                  </div>
                  <div className={styles.bblocks_card_name}>Сохранение комнатной температуры</div>
                </div>
                <div className={styles.bblocks_card} style={{ flex: 1 }}>
                  <div className={styles.bblocks_card_top}>
                    <div className={styles.bblocks_card_top_icon}>
                      <Image src={`/${assets_path}/images/sneg.svg`} width={17} height={19} />
                    </div>
                    <div className={styles.bblocks_card_top_sep} />
                    <div className={styles.bblocks_card_top_temp}>[-30°]</div>
                  </div>
                  <div className={styles.bblocks_card_name}>Защита от холодного воздуха</div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Komfort.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string
}

Komfort.defaultProps = {
  data: {},
  assets_path: ``
}

export default Komfort